const baseFactor = 8;

export const mobileMargin = {
  tiny: baseFactor * 2,
  small: baseFactor * 2,
  regular: baseFactor * 3,
  medium: baseFactor * 6
};

export const margin = {
  tiny: baseFactor * 4,
  small: baseFactor * 4 * 2,
  regular: baseFactor * 4 * 4,
  medium: baseFactor * 4 * 6,
  large: baseFactor * 4 * 8,
  xLarge: baseFactor * 4 * 12
};

export const mobilePadding = {
  tiny: baseFactor * 2, // 16px
  small: baseFactor * 2, //16px
  regular: baseFactor * 3, // 24px
  medium: baseFactor * 6 // 48px
};

export const padding = {
  minute: baseFactor * 2, // 16px
  tiny: baseFactor * 4, // 32px
  small: baseFactor * 4 * 2, // 64px
  xSmall: baseFactor * 3 * 3, // 72px
  regular: baseFactor * 4 * 3, // 96 px
  medium: baseFactor * 4 * 4, // 128 px
  large: baseFactor * 4 * 5, // 160px
  xLarge: baseFactor * 4 * 6 // 192px
};
